// import turbolinks from 'turbolinks';

import './components';
import { YoutubeLyteInitializer } from './utils/youtube-lyte';

import './style.css';

let scrollTop: number | null = null;
//let turbolinksFirstPageLoad = true;
const youtubeLyteInitializer = new YoutubeLyteInitializer();

/* function onTurboLinksLoad() {
  if (!turbolinksFirstPageLoad) {
    youtubeLyteInitializer.check();
  }

  const elements = document.querySelectorAll('[data-turbolinks-scroll]');

  elements.forEach(function (element) {
    element.addEventListener('click', () => {
      scrollTop = document.scrollingElement.scrollTop;
    });

    element.addEventListener('submit', () => {
      scrollTop = document.scrollingElement.scrollTop;
    });
  });

  if (scrollTop) {
    document.scrollingElement.scrollTo(0, scrollTop);
  }

  scrollTop = null;
  turbolinksFirstPageLoad = false;
} *
document.addEventListener('turbolinks:load', onTurboLinksLoad);

turbolinks.start();*/
